import { render, staticRenderFns } from "./UILanguages.vue?vue&type=template&id=663a0454&scoped=true&"
import script from "./UILanguages.vue?vue&type=script&lang=js&"
export * from "./UILanguages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663a0454",
  null
  
)

export default component.exports